import HandlingExtra from 'components/form/Stop/HandlingExtra/HandlingExtra.styled';

export default HandlingExtra;
